'use client'

import { useState } from 'react'

/**
 * Organizer bio, collapsed when it runs long.
 *
 * Imported profiles carry bios of wildly different lengths — most are a couple
 * of lines, but a handful run to several paragraphs and push the events list
 * off the screen. Anything past the threshold clamps to a few lines behind a
 * Read more toggle; shorter bios render untouched with no control.
 */

/** Bios longer than this get a toggle. Chosen from the real spread: bios are
 *  either under ~300 characters or over ~500, so this splits them cleanly. */
const COLLAPSE_OVER = 400

export function OrgBio({ bio, className = '' }: { bio: string; className?: string }) {
  const [expanded, setExpanded] = useState(false)
  const long = bio.length > COLLAPSE_OVER

  return (
    <div className={className}>
      <p
        className={[
          'whitespace-pre-line text-sm leading-relaxed text-white/80 lg:text-base',
          long && !expanded ? 'line-clamp-5' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {bio}
      </p>
      {long && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          className="mt-1.5 cursor-pointer text-sm font-medium text-white/60 underline-offset-2 transition-colors hover:text-white hover:underline"
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  )
}
